<script>
  import Layout from '@layout/main'
  import Login from '@components/Form/Login'
  import Registered from '@components/Form/Register'
  import { authComputed, globalComputed } from '@store/helpers'
  import appConfig from "@src/app.config.json";

  // FIXME: 要改成零壹提供的 liffId
  // const LIFF_ID = appConfig.liffId

  export default {
    components: {
      Layout,
      Login,
      Registered,
    },
    data() {
      return {
        activeTab: 'login',
        bindFinish: false,
        isBind: false,
        userId: this.$route.query.userId || '',
        pageId: this.$route.query.pageId || '',
        carry: this.$route.query.carry || '',
        lineData: {
          linkToken: this.$route.query.linkToken || '',
        },
        FBData: {
          redirect_uri: this.$route.query.redirect_uri || '',
          account_linking_token: this.$route.query.account_linking_token || '',
        },
        profile: {},
      }
    },
    computed: {
      ...authComputed,
      ...globalComputed,
      isRedirectFrom() {
        let result = false
        if(this.userId && this.pageId && this.carry) {
          if(!!this.lineData.linkToken) {
            result = "LINE"
          }
          if(!!this.FBData.redirect_uri && !!this.FBData.account_linking_token) {
            result = "FACEBOOK"
          }
        }
        return result
      },
      getRedirectUrl() {
        const currentUser = JSON.parse(window.localStorage.getItem('auth.currentUser'))
        let redirectUrlObj = new URL("https://rd.botbonnie.com/account/link")
        redirectUrlObj.searchParams.set('carry', this.carry)
        switch(this.isRedirectFrom) {
          case "LINE":
            if(currentUser.uuid){
              redirectUrlObj.searchParams.set('linkToken', this.lineData.linkToken)
              redirectUrlObj.searchParams.set('nonce', currentUser.uuid)
            } else {
              redirectUrlObj = false
            }
            break
          case "FACEBOOK":
            if(currentUser.uuid){
              redirectUrlObj.searchParams.set('redirect_uri', this.FBData.redirect_uri)
              redirectUrlObj.searchParams.set('account_linking_token', this.FBData.account_linking_token) 
              redirectUrlObj.searchParams.set('authorization_code', currentUser.uuid) 
            } else {
              redirectUrlObj = false
            }
            break
          default:
            redirectUrlObj = false
            break
        }
        return redirectUrlObj
      }
    },
    created() {
      if(!this.isRedirectFrom) {
        alert("登入資料取得失敗")
        window.location.href =  window.location.origin;
      }
    },
    methods: {
      async handleBotBonnieLogin() {
        let submitData = {
          userId: this.userId,
          platform: this.isRedirectFrom,
          pId: this.pageId
        }
        await this.$store.dispatch("auth/bindBotBonnie", submitData)
          .then(() => {
            this.bindFinish = true
            if(this.getRedirectUrl) {
              const redirectUrlObj = this.getRedirectUrl
              setTimeout(() => {
                window.location = redirectUrlObj.href
              }, 3000)
            }
          })
          .catch((err) => {
            if(err.message === '此帳號已綁定') { this.isBind = true }
          })
      },
      handleRegistered() {
        this.activeTab = "login"
      },
    },
  }
</script>
<template>
  <Layout type="liff">
    <section :class="$style.sectionLoing" class="section bg-gray-2">
      <div class="container--smaller">
        <div class="section__block">
          <template v-if="!isBind">
            <el-tabs v-if="!bindFinish" v-model="activeTab" stretch class="isStyleBase">
              <el-tab-pane label="會員登入" name="login">
                <Login @login="handleBotBonnieLogin"/>
              </el-tab-pane>
              <el-tab-pane label="註冊會員" name="registered">
                <Registered @done="handleRegistered"/>
              </el-tab-pane>
            </el-tabs>
            <div v-else>
              <div class="text-center">
                <i class="fa-4x fal fa-check-circle" style="color: #60A32F;"></i>
              </div>
              <h3 class="mt-4 mb-5 text-center">會員登入成功</h3>
              <p class="text-center pl-4 pr-4">
                3秒後將您導回BotBonnie，進行Line綁定！
              </p>
            </div>
          </template>
          <div v-else>
            <div class="text-center">
              <i class="fa-4x fal fa-exclamation-triangle text-warning"></i>
            </div>
            <h3 class="mt-4 mb-5 text-center">已綁定</h3>
            <p class="pl-4 pr-4 text-center">
              此登入帳號已綁定BotBonnie會員<br>欲綁定其他帳號請點選下方<span class="color-primary">綁定其他帳號</span>按鈕
            </p>
            <div class="d-sm-flex">
              <BaseButton
                class="isStylePrimary w-sm-50 w-100 mt-5 mr-sm-3 mr-0"
                :to="{ name: 'home' }"
              >
                前往首頁
              </BaseButton>
              <BaseButton
                class="isStylePrimary w-sm-50 w-100 mt-sm-5 mt-3"
                @click="isBind = false"
              >
                綁定其他帳號
              </BaseButton>
            </div>
          </div>
        </div>
      </div>
    </section>
  </Layout>
</template>
<style lang="scss" module>
  .sectionLoing {
    min-height: calc(100vh - 113px);
    @include max-lg {
      min-height: calc(100vh - 93px);
    }
    @include max-md {
      min-height: calc(100vh - 70px);
    }
    :global {
      .sectionLoing {

      }
    }
  }
</style>
